import { ExerciseId, Settings } from "../types";

export function getUserId(): string {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return localStorage.getItem("userId")!;
}

export function getTabId(): string {
    // we assume tabId will be defined because it is set in the App component
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return sessionStorage.getItem("tabId")!;
}

export function getFavouritesIds(): ExerciseId[] {
    const data = localStorage.getItem("favourites");
    return data ? JSON.parse(data) : [];
}

export function isFavourite(id: ExerciseId): boolean {
    return getFavouritesIds().includes(id);
}

export function getExcludedIds(): ExerciseId[] {
    const data = localStorage.getItem("excluded");
    return data ? JSON.parse(data) : [];
}

export function isExcluded(id: ExerciseId): boolean {
    return getExcludedIds().includes(id);
}

export function setFavouriteId(favouriteId: ExerciseId, value: boolean) {
    const currentFavourites = getFavouritesIds();
    if (value) {
        if (!isExcluded(favouriteId)) {
            localStorage.setItem("favourites", JSON.stringify(Array.from(new Set([...currentFavourites, favouriteId]))));
        }
    } else {
        localStorage.setItem("favourites", JSON.stringify(currentFavourites.filter((x) => x !== favouriteId)));
    }
}

export function setExcludedId(excludedId: ExerciseId, value: boolean) {
    const currentExcluded = getExcludedIds();
    if (value) {
        if (!isFavourite(excludedId)) {
            localStorage.setItem("excluded", JSON.stringify(Array.from(new Set([...currentExcluded, excludedId]))));
        }
    } else {
        localStorage.setItem("excluded", JSON.stringify(currentExcluded.filter((x) => x !== excludedId)));
    }
}

const defaultSettings: Settings = {
    discreet: "no",
    categories: [],
    favourite: "no",
};

export function getSettings(): Settings {
    const settingsInLocalStorage = JSON.parse(localStorage.getItem("settings") ?? "{}");
    return { ...defaultSettings, ...settingsInLocalStorage };
}

export function setSettings(settings: Settings) {
    localStorage.setItem("settings", JSON.stringify(settings));
}
